<template>
  <MobileMain v-if="mobileView" />
  <main-without-content-navbar v-else-if="$route.meta.layoutStatus === 'profile'" />
  <desktop-main v-else />
</template>

<script>
import {mapGetters} from 'vuex'
import MobileMain from './MobileMain.vue'
import DesktopMain from './desktopMain.vue'
import MainWithoutContentNavbar from '@/layouts/main/mainWithoutContentNavbar.vue'
const moment = require('moment-jalaali')

export default {
  name: 'Main',
  components: {MainWithoutContentNavbar, DesktopMain, MobileMain},
  computed: {
    ...mapGetters({
      isMobile: 'isMobile'
    })
  },
  data () {
    return {
      mobileView: false
    }
  },
  created () {
    this.mobileView = this.isMobile
  },
  mounted () {
    moment.loadPersian({dialect: 'persian-modern'})
  },
  watch: {
    /*isMobile: {
      handler (val) {
        if (!this.$store.state.pageHaveChanges) {
          this.mobileView = val
        }
      }
    },*/
    '$store.state.pageHaveChanges': {
      handler (val) {
        if (!val) {
          this.mobileView = this.isMobile
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
